export const readPersistedJson = key => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const writePersistedJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // localStorage may be unavailable
  }
};

export const removePersistedKey = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    // localStorage may be unavailable
  }
};



// WEBPACK FOOTER //
// ./src/helpers/twoFactorPersistedStorage.js